<template>
 <div id="manman">
  <div class="mobileTop"></div>
  <!-- <div class="topPart">
    <span class="backToApp" @click="backToApp()"></span><i class="share"></i>
  </div> -->
  <div class="logo slide"></div>
  <div class="guid">
    <ul class="guidList">
      <li class="shake" v-for="(item,index) in iconList" :key="index">
        <div class="tabs slide" @click.stop.prevent="toList(index)">
          <img :src="item.url" alt="" class="icon">
          <p class="name">{{item.name}}</p>
        </div>
      </li>
    </ul>
  </div>
  <div class="area">
    <p class="tit slide">应急场景</p>
    <ul class="slider">
      <li class="slidePart" @click="toArea(item.id,item.name)"  v-for="(item,index) in areaList" :key="index">
        <div class="box slide">
          <p class="tit">{{ item.name }}</p>
          <img :src="item.src" alt="" class="bg">
        </div>
      </li>
    </ul>
  </div>
  <div class="require">
    <p class="tit slide">需求定制</p>
    <div class="boxArea">
      <div class="leftBox slide" @click="goServe('goods')"></div>
      <div class="rightBox slide" @click="goServe('serve')"></div>
    </div>
  </div>
  <div class="experience">
    <p class="tit">来“缦遇生活屋”挑选体验</p>
    <ul class="goods">
      <li class="slidePart" @click="goGoods(item.goods_id,item.business_id)" v-for="(item,index) in goodsList" :key="index">
         <div class="goodsItem">
            <img :src="item.cover" alt="" class="cover">
            <p class="name">{{ item.goodsName }}</p>
            <p class="price">￥<span class="dot">{{ item.price }}</span></p>
         </div>
      </li>
    </ul>
  </div>
  <server></server>
 </div>
</template>

<script>
import server from './component/server.vue'
export default {
  components: {
    server
  },
  data () {
    return {
      iconList: [
        {
          url: require('./images/bell.png'),
          name: '应急'
        },
        {
          url: require('./images/extinguish.png'),
          name: '灭火'
        },
        {
          url: require('./images/protect.png'),
          name: '防护'
        },
        {
          url: require('./images/escape.png'),
          name: '逃生'
        },
        {
          url: require('./images/safebeg.png'),
          name: '安全包'
        }
      ],
      areaList: [
        {
          name: '家庭消防',
          src: require('./images/jia.jpg'),
          id: 'house'
        },
        {
          name: '出行安全',
          src: require('./images/chu.jpg'),
          id: 'outdoor'
        },
        {
          name: '儿童应急',
          src: require('./images/er.jpg'),
          id: 'child'
        },
        {
          name: '防护穿戴',
          src: require('./images/fang.jpg'),
          id: 'wear'
        },
        {
          name: '企业安全',
          src: require('./images/qi.jpg'),
          id: 'company'
        },
        {
          name: '仓库工厂',
          src: require('./images/cang.jpg'),
          id: 'factory'
        }
      ],
      goodsList: [
        {
          cover: 'https://cdn.zxzx119.com/1541282223213248512',
          goodsName: '火焰战士 简易式水基灭火器 MSWJ550 全向喷射360°',
          price: '69.00',
          goods_id: '11166',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1659082543711911936',
          goodsName: '火焰战士 灭火逃生花瓶FF-SKJ650',
          price: '98.00',
          goods_id: '11899',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541287800068898816',
          goodsName: '火焰战士 多功能停车牌安全锤 CS-B08',
          price: '49.00',
          goods_id: '11168',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1597463025386782720',
          goodsName: '火焰战士 硅胶灭火毯1*1m ',
          price: '68.00',
          goods_id: '11456',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1597466473444409344',
          goodsName: '火焰战士 硅胶灭火毯1.5*1.5m ',
          price: '98.00',
          goods_id: '11457',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541255500341968896',
          goodsName: '火焰战士 过滤式自救呼吸器 TZL30 硅胶款',
          price: '58.00',
          goods_id: '11163',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541258791289356288',
          goodsName: '火焰战士 过滤式自救呼吸器 TZL30 硅胶儿童款',
          price: '62.00',
          goods_id: '11165',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541256106624417792',
          goodsName: '火焰战士 过滤式自救呼吸器 TZL30 硅胶夜光款',
          price: '65.00',
          goods_id: '11164',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541242299529297920',
          goodsName: '火焰战士 防火斗篷防高温浸泡型 成人款',
          price: '168.00',
          goods_id: '11161',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1541242299529297920',
          goodsName: '火焰战士 防火斗篷防高温浸泡型 儿童款',
          price: '158.00',
          goods_id: '11162',
          business_id: '26359'
        },
        {
          cover: 'https://cdn.zxzx119.com/1682288255275368448',
          goodsName: '【中消集团】消防应急箱（pp箱）',
          price: '1799.00',
          goods_id: '12512',
          business_id: '26435'
        },
        {
          cover: 'https://cdn.zxzx119.com/1680888399612870656',
          goodsName: '【中消集团】消防应急箱（铝箱）',
          price: '1799.00',
          goods_id: '12511',
          business_id: '26435'
        }
      ]
    }
  },
  mounted () {
    this.startSlide()
  },
  created () {

  },
  methods: {
    goGoods (gid, bid) {
      this.$router.push({
        path: '/myGoods',
        query: {
          goodsId: gid,
          businessId: bid
        }
      })
    },
    toArea (id, name) {
      this.$router.push({
        path: '/myArea',
        query: {
          name: name,
          id: id
        }
      })
    },
    goServe (str) {
      if (str == 'goods') {
        this.$router.push({
          path: '/goodsMy'
        })
      } else {
        this.$router.push({
          path: '/serveMy'
        })
      }
    },
    backToApp () {
      window.history.go(-1)
    },
    toList (key) {
      let cnode = [...document.querySelector('#manman').childNodes]
      cnode.forEach((item, index) => {
        if (index !== 2 && item.nodeName == 'DIV') {
          item.classList.add('hide')
        }
      })
      setTimeout(() => {
        // const {aplus_queue} = window
        // aplus_queue.push({
        //   action: 'aplus.sendPV',
        //   arguments: [{
        //     is_auto: false
        //   }, {
        //     param1: 111,
        //     param2: '222'
        //   }]
        // })
        this.$router.push({
          path: '/guidList',
          query: {
            tab: key
          }
        })
      }, 1000)
    },
    startSlide () {
      let DomList = [...document.querySelectorAll('.slide')]
      for (let n = 0; n < DomList.length; n++) {
        setTimeout(() => {
          DomList[n].classList.remove('slide')
          DomList[n].classList.add('slideUp')
        }, n * 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
margin: 0;
padding: 0;
}
@keyframes out {
  0%,
  10%{
    opacity: 1;
    transform:translateX(-5px);
  }
  20%{
    opacity: 0.8;
  }
  40%{
    opacity: 0.6;
  }
  60%{
    opacity: 0.4;
  }
  80%{
    opacity: 0.2;
  }
  100%{
    opacity: 0;
    transform:translateX(375px);
  }
}
.hide{
  animation: out 0.8s ease-in forwards;
}
#manman{
  display: inline-block;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: url('./images/bg.svg') top no-repeat,#ffffff;
  background-position-y: -160px;
  padding:0 16px;
  .slide {
    margin-top: 150px;
    visibility: visible;
    opacity: 0;
    transition: all 0s;
    -webkit-transition: all 0s;
    -ms-transition: all 0s;
    -moz-transition: all 0s;
  }
  // .slideIn1{
  //   margin-top: 150px;
  //   visibility: visible;
  //   opacity: 0;
  //   transition: all 0s;
  //   -webkit-transition: all 0s;
  //   -ms-transition: all 0s;
  //   -moz-transition: all 0s;
  // }
  // .slideIn2{
  //   margin-top: 150px;
  //   visibility: visible;
  //   opacity: 0;
  //   transition: all 0s;
  //   -webkit-transition: all 0s;
  //   -ms-transition: all 0s;
  //   -moz-transition: all 0s;
  // }
  .slideUp {
    margin-top: 0px;
    opacity: 1;
    transition: all 0.6s;
    -webkit-transition: all 0.6s;
    -ms-transition: all 0.6s;
    -moz-transition: all 0.6s;
    transition-delay: 0.5s;
    -moz-transition-delay: 0.5s;
    -webkit-transition-delay: 0.5s;
  }
  .mobileTop{
    height: 27px;
  }
  .topPart{
    display: inline-block;
    width: 100%;
    height: 30px;
    position: relative;
    margin-bottom:16.5px;
    .backToApp{
      display: inline-block;
      position: relative;
      width: 30px;
      height: 30px;
      line-height: 30px;
      &::before{
        content: '';
        position: absolute;
        left: 0;
        top: calc(50% - 6px);
        right: 0;
        margin: 0 auto;
        width: 12px;
        height: 12px;
        border-top: 2px solid #1D2129;
        border-left: 2px solid #1D2129;
        transform: rotate(-45deg);
      }
    }
    .share{
        position: absolute;
        right: 0;
        width: 30px;
        height: 30px;
        background: url('./images/shareBtn.svg')no-repeat center center;
        background-size: cover;
    }
  }
  .logo{
    display: inline-block;
    width: 100%;
    height: 50px;
    margin-bottom: 22px;
    background: url('./images/logo.svg') no-repeat left center;

    background-size: contain;
  }
  .guid{
    display: inline-block;
    width: 100%;
    margin-bottom: 50px;
    // white-space: nowrap;
    .guidList{
      display: inline-block;
      width: 100%;
      overflow-x: auto;
      li{
        display: inline-block;
        width:60px;
        height: 90px;
        margin-right: 10px;
        overflow: hidden;
        .tabs{
          display: inline-block;
          // word-break: unset;
          // word-break: break;
          .icon{
            width: 60px;
            height: 60px;
            border-radius: 5px;
            background: #ffffff;
            padding: 15px;
            margin-bottom: 5px;
          }
          .name{
            display: inline-block;
            width: 60px;
            height: 13px;
            line-height: 13px;
            color: #000000;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .area{
    display: inline-block;
    width: 100%;
    margin-bottom: 35px;
    // height: 160px;
    .tit{
      font-family: Source Han Sans CN;
      font-size: 16px;
      color: #000000;
      margin-bottom: 15px;
    }
    .slider{
      display: inline-block;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      &::-webkit-scrollbar{
        display:none;
      }
      .slidePart{
        height: 140px;
        white-space: normal;
        display: inline-block;
        margin-right: 10px;
        .box{
          position: relative;
          vertical-align: top;
          display: inline-block;
          width: 150px;
          border-radius: 5px;
          text-align: center;
          padding: 14px 10px 10px 10px;
          background: #F6F6F6;
          .tit{
            vertical-align: top;
            display: inline-block;
            line-height: 14px;
            height: 14px;
            width: 100%;
            text-align: left;
            font-size: 14px;
            color: #1D2129;
            margin-bottom: 14px;
          }
          .bg{
            display: inline-block;
            width:130px;
            height: 87px;
            border-radius: 2px;
          }
          &::after{
            content: "→";
            position: absolute;
            font-size: 14px;
            right: 10px;
            top: 11px;
            color: #9e918b;
            font-weight: bolder;
          }
        }

        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .require{
    display: inline-block;
    width: 100%;
    margin-bottom: 35px;
    .tit{
      font-family: Source Han Sans CN;
      font-size: 16px;
      color: #000000;
      margin-bottom: 15px;
    }
    .boxArea{
      display: inline-block;
      width: 100%;
      height: 80px;
      .leftBox{
        vertical-align: top;
        float:left;
        width: 170px;
        height: 77px;
        background: url('./images/goods.png') no-repeat center center;
        background-size: contain;
      }
      .rightBox{
        vertical-align: top;
        float: right;
        width: 170px;
        height: 77px;
        background: url('./images/server.png') no-repeat center center;
        background-size: contain;
      }
    }
  }
  .experience{
    display: inline-block;
    width: 100%;
    .tit{
      font-family: Source Han Sans CN;
      font-size: 16px;
      color: #000000;
      margin-bottom: 17px;
    }
    .goods{
      display: inline-block;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      .slidePart{
        display: inline-block;
        white-space: normal;

        height: 217px;
        margin-right: 15px;
        .goodsItem{
          position: relative;
          vertical-align: top;
          display: inline-block;
          width: 140px;
          border-radius: 5px;
          text-align: center;
          .cover{
            display: inline-block;
            width: 140px;
            height: 140px;
            padding: 10px 35px;
            border-radius: 5px;
            background: #F7F7F7;
          }
          .name{
            display: inline-block;
            position: relative;
            text-align: left;
            line-height: 15px;
            height: 15px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #1D2129;
            margin-bottom: 32px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &::after{
              content:'';
              position: absolute;
              width: 66px;
              height: 19px;
              background: url('./images/vip.png')no-repeat center center;
              background-size: contain;
              left: 0;
              bottom: 30px;
            }
          .price{
            text-align: left;
            font-size: 12px;
            color: #9e918b;
            height: 18px;
            .dot{
              font-size: 18px;
              color: #9e918b;
              line-height: 18px;
              display: inline-block;
              margin-left: 2px;
            }
          }
        }
      }
      &::-webkit-scrollbar{
        display:none;
      }
    }
  }
  &::-webkit-scrollbar{
    display:none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/manman/homePage.vue